import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentAddFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2Zm7 3v4H7v2h4v4h2v-4h4V9h-4V5h-2Z"
    />
  </svg>
);
export default IconCommentAddFilledSizeM;
